import React, { memo, useCallback, useRef } from "react"
import styled from "styled-components"
import { getHtmlFromRedactorField } from "@/utils/utils"
import Text from "@/components/common/Text"
import { NO_LIST_ITEM } from "@/components/ExpandingListAndDescription/List"
import useScrollContext from "@/hooks/useScrollContext"
import { gsap, useGSAP } from "@/utils/gsap"

const Wrapper = styled.div`
	width: 100%;
	overflow: hidden;
	border-bottom: solid 1px crimson;
	--local-padding: 15px 0;

	&.active {
		.collapsible {
			opacity: 1;
			pointer-events: auto;
		}
	}
`

const Collapsible = styled.div`
	transition: opacity var(--rgr-duration) var(--ease);
	height: 100%;
	opacity: 0;
	overflow: hidden;
	pointer-events: none;
	max-height: 0;
`

const Desc = styled(Text)`
	padding: var(--local-padding);
`
const Controller = styled.div`
	width: 100%;
	justify-content: space-between;
	padding: var(--local-padding);
	cursor: pointer;
`

const ListItem = ({ data, moreText = "", lestText = "", onClick, active = false }) => {
	const WrapperRef = useRef()
	const id = data?.id || ""
	const header = data?.header || ""
	const description = getHtmlFromRedactorField(data?.description || "")
	const CollapsibleRef = useRef()
	const scroll = useScrollContext()

	const handleOnClick = useCallback(() => {
		const newItem = active ? NO_LIST_ITEM : { ...data, ref: WrapperRef.current } //if this is already active reset to no item
		onClick(newItem)
	}, [active, data, onClick])

	useGSAP(
		() => {
			let targetHeight = 0
			if (active) {
				console.log(CollapsibleRef.current.children)
				targetHeight = CollapsibleRef.current.children?.[0]?.getBoundingClientRect().height || 0
			}
			gsap.to(CollapsibleRef.current, {
				maxHeight: `${targetHeight}px`,
				onComplete: () => {
					scroll.refresh() //update scroll values
				},
			})
		},
		{
			dependencies: [active],
			revertOnUpdate: false,
		},
	)

	return (
		<Wrapper id={id} ref={WrapperRef} className={`${active ? "active" : ""}`} aria-expanded={active}>
			<Controller onClick={handleOnClick}>
				<Text className="typo-borna-14">{header}</Text>
				<Text className="typo-borna-12">{active ? lestText : moreText}</Text>
			</Controller>
			<Collapsible ref={CollapsibleRef} className="collapsible" aria-hidden={!active}>
				<Desc tag="div" className="typo-borna typo-borna-5" dangerouslySetInnerHTML={description} />
			</Collapsible>
		</Wrapper>
	)
}

export default memo(ListItem)
